export default __webpack_public_path__ + "static/media/video-poster.895a30ea.png";